import React, { useState } from 'react';

interface ContactFormData {
  nombre: string;
  email: string;
  telefono: string;
  equipo: string;
  mensaje: string;
}

export const ContactSection: React.FC = () => {
  const [formData, setFormData] = useState<ContactFormData>({
    nombre: '',
    email: '',
    telefono: '',
    equipo: 'Laptop',
    mensaje: '',
  });

  const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d498.36516826668066!2d-79.9862733999798!3d-2.183532529364156!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x902d73e761ef3a65%3A0x26d4b2207ec078b1!2sGaredtech!5e0!3m2!1ses!2sus!4v1785040369088!5m2!1ses!2sus"; // Reemplaza con tu URL de Google Maps

  const [enviado, setEnviado] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Aquí puedes conectar el envío hacia un Controller de Laravel usando Inertia router.post(...)
    console.log('Datos enviados:', formData);
    setEnviado(true);
    setTimeout(() => setEnviado(false), 4000);
  };

  return (
    <section className="w-full bg-slate-900 text-slate-100 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto space-y-12">
        
        {/* Encabezado de la sección */}
        <div className="text-center space-y-3">
          <span className="inline-block bg-sky-500/10 text-sky-400 font-bold text-xs uppercase tracking-widest px-3 py-1 rounded-full border border-sky-500/20">
            Atención Inmediata
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight">
            ¿Necesitas presupuestar tu <span className="text-sky-400">reparación</span>?
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-sm sm:text-base">
            Contáctanos por WhatsApp para una respuesta rápida o déjanos un mensaje detallado para coordinar tu servicio técnico.
          </p>
        </div>

        {/* Tarjetas Informativas Rápidas */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Teléfono / WhatsApp */}
          <div className="bg-slate-800/80 border border-slate-700/60 rounded-2xl p-6 flex items-start space-x-4 hover:border-sky-500/50 transition-colors">
            <div className="bg-sky-500/10 p-3 rounded-xl text-sky-400">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
            </div>
            <div>
              <h3 className="font-bold text-base text-white">WhatsApp & Teléfono</h3>
              <p className="text-slate-400 text-xs mt-1">Consultas directas y turnos</p>
              <a href="https://wa.me/+593991722575" target="_blank" rel="noreferrer" className="inline-block mt-2 text-sky-400 font-semibold text-sm hover:underline">
                +593 991 722 575
              </a>
            </div>
          </div>

          {/* Correo Electrónico */}
          <div className="bg-slate-800/80 border border-slate-700/60 rounded-2xl p-6 flex items-start space-x-4 hover:border-sky-500/50 transition-colors">
            <div className="bg-sky-500/10 p-3 rounded-xl text-sky-400">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 002-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <h3 className="font-bold text-base text-white">Correo Electrónico</h3>
              <p className="text-slate-400 text-xs mt-1">Soporte y facturación</p>
              <a href="mailto:contacto@garedtech.com" className="inline-block mt-2 text-sky-400 font-semibold text-sm hover:underline">
                info@garedtech.com
              </a>
            </div>
          </div>

          {/* Horario de Atención */}
          <div className="bg-slate-800/80 border border-slate-700/60 rounded-2xl p-6 flex items-start space-x-4 hover:border-sky-500/50 transition-colors">
            <div className="bg-sky-500/10 p-3 rounded-xl text-sky-400">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h3 className="font-bold text-base text-white">Horario de Atención</h3>
              <p className="text-slate-400 text-xs mt-1">Lunes a Viernes: 9:00 - 17:30</p>
              <p className="text-slate-400 text-xs">Sábados: 9:00 - 12:00</p>
            </div>
          </div>
        </div>

        {/* Formulario e Información Principal */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 bg-slate-800/40 border border-slate-700/50 rounded-3xl p-6 sm:p-10 shadow-2xl">
       
          <div className="lg:col-span-7">
            <span className="text-sky-400 text-s font-bold tracking-widest uppercase">Ubicación</span>
            
            <iframe
              title="Ubicación del Taller Técnico"
              src={mapEmbedUrl}
              width="100%"
              
              style={{ border: 0 }}
              allowFullScreen={false}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full my-3 grayscale-20 contrast-110 hover:grayscale-0 transition-all duration-300 rounded"
            ></iframe>
            <p className="text-slate-300 text-s leading-relaxed">
             Centro Cormecial Blue Coast, Km 13 Via a la Costa, Planta Alta Local 13
            </p>
          </div>
          {/* Lado Derecho: Call-to-Action y detalles */}
          <div className="lg:col-span-5 bg-linear-to-br from-sky-900/40 to-slate-900 p-6 sm:p-8 rounded-2xl border border-sky-500/20 flex flex-col justify-between">
            <div className="space-y-4">
              <span className="text-sky-400 text-xs font-bold tracking-widest uppercase">Diagnóstico Profesional</span>
              <h4 className="text-xl font-extrabold text-white">¡Escríbemos!</h4>
              <p className="text-slate-300 text-xs leading-relaxed">
                Haciendo clic en el botón de abajo puedes abrir un chat directo por WhatsApp con nuestro taller técnico para coordinar la revisión de tu equipo.
              </p>
            </div>

            <div className="mt-8 space-y-3">
              <a
                href="https://wa.me/+593991722575?text=Hola,%20quisiera%20consultar%20por%20un%20presupuesto"
                target="_blank"
                rel="noreferrer"
                className="w-full inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold py-3 px-4 rounded-xl transition-all text-sm"
              >
                <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981z"/>
                </svg>
                Hablar por WhatsApp
              </a>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};